import React from 'react';
import { Heading } from "@react-spectrum/s2";
import './AppScreenTitle.css';
export interface AppScreenTitleProps {
    /** Primary page title */ title: React.ReactNode;
    /**
   * Bold context (e.g. domain name) shown before the title with a divider bar —
   * Figma "Site ▏ Page" header (726:420537). The title then renders in regular weight.
   */ context?: React.ReactNode;
    /** Optional line below the title (meta, description) */ subtitle?: React.ReactNode;
    /** Icon or node before the title (embedded layout only; the Figma page header has no icon) */ leading?: React.ReactNode;
    /** Toolbar actions / search (right side); only used when layout is "page" */ trailing?: React.ReactNode;
    /**
   * page — padded header bar (domain / org tool screens).
   * embedded — title stack only, for flows inside a form (e.g. Add content).
   */ layout?: 'page' | 'embedded';
    className?: string;
    id?: string;
}
/**
 * Shared title treatment for main app views (Analytics, Indexed content, Chat history, etc.).
 */ export const AppScreenTitle: React.FC<AppScreenTitleProps> = ({ title, context, subtitle, leading, trailing, layout = 'page', className = '', id })=>{
    const headingContent = context != null ? (<>
      <span className="main-view-heading__context">{context}</span>
      <span className="main-view-heading__divider" aria-hidden/>
      <span className="main-view-heading__page">{title}</span>
    </>) : title;
    const titleRow = (<div className={" sd171 eb171 Ue171 qe171"}>
      {layout === 'embedded' ? leading : null}
      <Heading level={3} id={id} UNSAFE_className={`main-view-heading__title${context != null ? ' main-view-heading__title--with-context' : ''}`} styles={" Jy171 Gy171 Iy171 Hy171"}>
        {headingContent}
      </Heading>
    </div>);
    const textColumn = (<div className="main-view-heading__text">
      {titleRow}
      {subtitle != null ? <div className="main-view-heading__subtitle">{subtitle}</div> : null}
    </div>);
    if (layout === 'embedded') {
        return <div className={`main-view-heading main-view-heading--embedded ${className}`.trim()}>{textColumn}</div>;
    }
    return (<div className={`main-view-heading main-view-heading--page ${className}`.trim()}>
      <div className="main-view-heading__inner">
        {textColumn}
        {trailing != null ? <div className="main-view-heading__trailing">{trailing}</div> : null}
      </div>
    </div>);
};

import "macro-670689c431bc3bbe3dd9c9217c99a533309a8e20cb86cb029d05484a86ca10f4.css";
import "macro-9265ce547da9b2dc6ffe8b0a3109d3facb0513bbd657f7ae9beeb5d91b71740f.css";